const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  token: state => state.user.token,
  visitedViews: state => state.tagsView.visitedViews,
  name: state => state.user.name,
  userInfo: state => state.user.userInfo || {},
  userId: state => state.user.userId,
  roles: state => state.user.roles
};
export default getters;
